import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';
import MediaLibraryItem from '../Components/media-library-item';
import { connect } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import isEmpty from 'lodash/isEmpty';
import orderBy from 'lodash/orderBy';

import * as CommonActionType from '../../Common/constants';
import * as MediaActionType from '../constants';
import * as RegionActionType from 'Region-Market/constants';

const MAXIMUM_VIDEO_SIZE = 1024 * 1024 * 500;

class ManageMediaLibraries extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    user: PropTypes.object,
    mode: PropTypes.string,
    hidden: PropTypes.bool,
    MediaList: PropTypes.object,
    mediaId: PropTypes.string,
    MediaCategories: PropTypes.array,
    SelectListRegions: PropTypes.array,
    ProjectList: PropTypes.array,
    CheckCopiedProject: PropTypes.object,
    ListCheckCopiedRegion: PropTypes.array
  };

  constructor(props) {
    super(props);
    this.AWSCredential = null;
    this.state = {
      files: [],
      cancelUploadList: {},
      deleteUploadList: {},
      disableEdit: true
    };
  }

  componentDidMount() {
    this.fetchVideo();
  }

  fetchVideo = () => {
    this.props.dispatch({
      type: MediaActionType.GET_LIST_MEDIA_ASYNC,
      params: {}
    });
  };

  onDrop = (accepted, rejected) => {
    if (rejected.length) {
      const errorMsg = 'Only MP4, MOV, WEBM supported.';
      this.setState({
        error: errorMsg
      });
    } else {
      const acceptLength = 3;
      if (accepted.length <= acceptLength) {
        if (accepted[0].size > MAXIMUM_VIDEO_SIZE) {
          this.setState({
            error: `File size must not exceed ${MAXIMUM_VIDEO_SIZE /
              (1024 * 1024)}MB.`
          });
        } else {
          const currentFileState = [...this.state.files];

          this.setState(
            {
              files: currentFileState.concat(accepted),
              error: null
            },
            () => this.handleFileUpload(accepted)
          );
        }
      } else {
        this.setState({
          error: `Maximum ${acceptLength} file${
            acceptLength === 1 ? '' : 's'
          } allowed at once.`
        });
      }
    }
  };

  handleFileUpload = files => {
    const {mediaId} = this.props;
    this.props.dispatch({
      type: CommonActionType.COMMON_SETUP_AWS_ASYNC,
      params: {
        resourcePath: `media/${mediaId}`
      },
      callback: awsCredential => {
        this.awsCredential = awsCredential;

        files.map(file => {
          file.uploadId = uuidv4();
          //handle image file
          this.props.dispatch({
            type: CommonActionType.COMMON_UPLOAD_FILE_TO_S3_ASYNC,
            paramsUpload: {
              mediaId,
              file,
              config: awsCredential
            },
            callback: (status, callbackData) => {
              callbackData.name = file.name;

              if (status === 'pending') {
                const { cancelUploadList } = this.state;
                cancelUploadList[callbackData.uploadId] =
                  callbackData.cancelUpload;
                this.setState({
                  cancelUploadList
                });
              } else if (status === 'delete') {
                const { deleteUploadList } = this.state;
                deleteUploadList[callbackData.uploadId] =
                  callbackData.deleteFile;
                this.setState({
                  deleteUploadList
                });
              } else if (status === true) {
                this.uploadVideoToServer(callbackData, callbackData);
              }
            }
          });
        });
      }
    });
  };

  uploadVideoToServer = (fileData, thumbnailData) => {
    this.props.dispatch({
      type: MediaActionType.ADD_MEDIA_ASYNC,
      params: {
        data: {
          fileName: fileData.name,
          key: fileData.data.Key,
          url: fileData.data.Location,
          thumbnailKey: thumbnailData.data.Key,
          thumbnailUrl: thumbnailData.data.Location
        }
      },
      callback: () => {
        this.setState({
          files: []
        });
      }
    });
  };

  onFetchCategory = () => {
    this.props.dispatch({
      type: MediaActionType.GET_MEDIA_BY_CATEGORIES_ASYNC,
      params: {}
    });
  }

  onFetchProject = () => {
    this.props.dispatch({
      type: MediaActionType.GET_PROJECT_LIST_ASYNC,
      params: {}
    });
  }

  onRemoveVideo = (item) => {
    this.props.dispatch({
      type: MediaActionType.DELETE_MEDIA_ASYNC,
      params: {id: item.id},
      callback: () => {
        this.fetchVideo();
      }
    });
  };

  onCopyProject = (params, callback) => {
    this.props.dispatch({
      type: MediaActionType.SET_COPY_MEDIA_TO_PROJECT_ASYNC,
      params: {
        mediaId: params.mediaId,
        projectIds: params.projectIds
      },
      callback
    });
  }

  onCheckCopyByRegion = (params) => {
    this.props.dispatch({
      type: MediaActionType.CHECK_COPY_MEDIA_BY_REGION_ASYNC,
      params: {
        mediaId: params.mediaId,
        projectIds: params.projectIds
      }
    });
  }

  onCheckCopyProjectDuplicate = (params) => {
    this.props.dispatch({
      type: MediaActionType.CHECK_COPY_MEDIA_ASYNC,
      params: {
        mediaId: params.mediaId,
        projectId: params.projectId
      }
    });
  }

  onUpdateVideoName = (item, callback) => {
    this.props.dispatch({
      type: MediaActionType.UPDATE_MEDIA_BY_ID_ASYNC,
      params: {
        id: item.id,
        fileName: item.fileName
      },
      callback
    });
  };

  onUpdateCategory = (params, callback) => {
    this.props.dispatch({
      type: MediaActionType.UPDATE_MEDIA_BY_ID_ASYNC,
      params: {
        id: params.id,
        mediaCategoryId: params.mediaCategoryId
      },
      callback
    });
  };

  onCancelUpload = fileData => {
    const item = fileData.file;

    const { cancelUploadList } = this.state;
    if (
      !isEmpty(cancelUploadList) &&
      Object.keys(cancelUploadList).includes(item.uploadId)
    ) {
      cancelUploadList[item.uploadId]();
      delete cancelUploadList[item.uploadId];
      this.setState({
        files: this.state.files.filter(
          element => element.uploadId !== item.uploadId
        ),
        cancelUploadList
      });
    }
    const { deleteUploadList } = this.state;
    if (
      !isEmpty(deleteUploadList) &&
      Object.keys(deleteUploadList).includes(item.uploadId)
    ) {
      deleteUploadList[item.uploadId]();
      delete deleteUploadList[item.uploadId];
      this.setState({
        files: this.state.files.filter(
          element => element.uploadId !== item.uploadId
        ),
        deleteUploadList
      });
    }
  };

  onClearError = () => {
    this.setState({ error: null });
  };

  //renderError
  renderError = () => {
    const { error } = this.state;

    if (error) {
      setTimeout(this.onClearError, 5000);
      return (
        <div
          className='alert alert-danger'
          style={{ width: '100%', margin: '0 15px 15px' }}
        >
          <p style={{ fontSize: 14 }}>{error}</p>
          <i
            className='fa fa-close'
            style={{
              position: 'absolute',
              top: 14,
              right: 14,
              cursor: 'pointer'
            }}
            onClick={this.onClearError}
          />
        </div>
      );
    }

    return null;
  };

  //renderMediaVideo
  renderMediaVideo = items => {
    const { MediaCategories, SelectListRegions, ProjectList, ListCheckCopiedRegion } = this.props;

    return orderBy(items, 'fileName', 'asc').map(item => {
      return (
        <MediaLibraryItem
          key={item.id}
          data={item}
          onRemoveVideo={() => this.onRemoveVideo(item)}
          onUpdateVideoName={this.onUpdateVideoName}
          onUpdateCategory={this.onUpdateCategory}
          onFetchCategory={this.onFetchCategory}
          MediaCategories={MediaCategories}
          SelectListRegions={SelectListRegions}
          onFetchRegion={this.onFetchRegion}
          ProjectList={ProjectList}
          onFetchProject={this.onFetchProject}
          onCopyProject={this.onCopyProject}
          onCheckCopyProjectDuplicate={this.onCheckCopyProjectDuplicate}
          onCheckCopyByRegion={this.onCheckCopyByRegion}
          ListCheckCopiedRegion={ListCheckCopiedRegion}
        />
      );
    });
  }

  onFetchRegion = () => {
    this.props.dispatch({
      type: RegionActionType.GET_LIST_REGION_ASYNC,
      params: {
        searchKey: '',
        selectedValue: ''
      }
    });
  };

  renderFileUploading = files => {
    const {user} = this.props;
    if (files.length) {
      return files.map((file, index) => {
        const data = {
          file,
          fileName: file.name,
          createBy: {
            displayName: user.fullName
          }
        };
        return (
          <MediaLibraryItem
            loading
            key={index}
            data={data}
            onCancelUpload={this.onCancelUpload}
            disableEdit={this.state.disableEdit}
          />
        );
      });
    }
    return null;
  };

  render() {
    const { files } = this.state;
    const acceptFileType = 'video/quicktime, video/x-quicktime, video/mp4, video/webm, audio/webm, video/mov';

    let items = this.props.MediaList;

    return (
      <div id='manage-media-libraries'>

        <div className='page-title clearfix'>
          <h2 className='pull-left'>Media Library</h2>
        </div>

        <div className='box-form-siteone col-xs-12 col-sm-12 col-lg-12'>
          <div style={{ marginLeft: '10px', paddingBottom: '10px' }} className='clearfix'>
            <h3 className='pull-left'>Videos</h3>
          </div>

          {this.renderError()}

          {this.renderMediaVideo(items)}

          {this.renderFileUploading(files)}

          <Dropzone
            disableClick
            accept={acceptFileType}
            ref={node => { this.dropzoneRef = node; }}
            onDrop={this.onDrop.bind(this)}
            className='media-library-dropzone col-sm-3 col-md-3 col-lg-3'
          >
            <div className='upload-block'>

              <span className='files-upload-ic'>
                <i className='fa fa-cloud-upload' />
              </span>
              Drag files here or{' '}

              <span className='files-browse-txt' onClick={() => { this.dropzoneRef.open(); }}>
                browse.
              </span>

            </div>
          </Dropzone>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.UserStore.UserProfile,
    MediaStore: state.MediaStore,
    MediaList: state.MediaStore.MediaList,
    MediaCategories: state.MediaStore.MediaCategories,
    SelectListRegions: state.RegionMarketStore.SelectListRegions,
    ProjectList: state.MediaStore.ProjectList,
    ListCheckCopiedRegion: state.MediaStore.ListCheckCopiedRegion
  };
};

export default connect(mapStateToProps)(ManageMediaLibraries);



// WEBPACK FOOTER //
// ./src/MediaLibrary/Containers/manage-media-libraries.js